export const emitSectionEvent = (section, { type , detail  })=>{
    const evt = new CustomEvent(type, {
        detail,
        bubbles: true,
        cancelable: false
    });
    section.dispatchEvent(evt);
};
